export const COURSE_ABBRS = [
  'BDI',
  'ADI12',
  'WCD',
  'TLSAE',
  // 'FLPERMIT', // Uncomment if you want to include this course
  'SDDAFL',
  'TOAD',
  'BDI8',
  'ADI',
  'TOAD8',
  'STOP',
  'FLBSC',
  // 'FLRST',
  'FLDETS',
];
